import React from 'react';
import { Card, CardGroup} from 'react-bootstrap';
import img1 from '../../../images/10.jpg';
import img2 from '../../../images/11.jpg';
import img3 from '../../../images/12.jpg';


const Gallery = () => {
    return (
        <div className="container p-5">
        <h5>From the Blog</h5>
        <h2 className="text-danger">Latest news & articles directly  <br /> coming from blog</h2>
         <div>
         <Card className="m-5">
    <Card.Img variant="top" src={img1} />
    <Card.Body>
      <Card.Title>Oral Contraceptive Pills Protect Against</Card.Title>
      <Card.Text>
        This is a wider card with supporting text below as a natural lead-in to
        additional content. This content is a little bit longer.a wider card with supporting text below as a natural lead-in to
        additional content. This content is a little bit longer.a wider card with supporting text below as a natural lead-in to
        additional content. This content is a little bit longer.
      </Card.Text>
    </Card.Body>
    <Card.Footer>
      <small className="text-muted d-flex justify-content-around">
      <div><i className="fas fa-user text-danger "></i> Admin</div>
      <div><i className="far fa-comments text-danger"></i>2 Comments</div>
      <div><i className="fas fa-share-square text-danger"></i>5 Share</div>
      </small>
    </Card.Footer>
  </Card>
  <Card className="m-5">
    <Card.Img variant="top" src={img2} />
    <Card.Body>
      <Card.Title>Reducing the Side-Effects of Prostate Hormone</Card.Title>
      <Card.Text>
      This is a wider card with supporting text below as a natural lead-in to
        additional content. This content is a little bit longer.a wider card with supporting text below as a natural lead-in to
        additional content. This content is a little bit longer.a wider card with supporting text below as a natural lead-in to
        additional content. This content is a little bit longer.
      </Card.Text>
    </Card.Body>
    <Card.Footer>
    <small className="text-muted d-flex justify-content-around">
      <div><i className="fas fa-user text-danger "></i> Admin</div>
      <div><i className="far fa-comments text-danger"></i>2 Comments</div>
      <div><i className="fas fa-share-square text-danger"></i>5 Share</div>
      </small>
    </Card.Footer>
  </Card>
  <Card className="m-5">
    <Card.Img variant="top" src={img3} />
    <Card.Body>
      <Card.Title>Schoolchildren Unlikely to Transmit SARS</Card.Title>
      <Card.Text>
      This is a wider card with supporting text below as a natural lead-in to
        additional content. This content is a little bit longer.a wider card with supporting text below as a natural lead-in to
        additional content. This content is a little bit longer.a wider card with supporting text below as a natural lead-in to
        additional content. This content is a little bit longer.
      </Card.Text>
    </Card.Body>
    <Card.Footer>
    <small className="text-muted d-flex justify-content-around">
      <div><i className="fas fa-user text-danger "></i> Admin</div>
      <div><i className="far fa-comments text-danger"></i>2 Comments</div>
      <div><i className="fas fa-share-square text-danger"></i>5 Share</div>
      </small>
    </Card.Footer>
  </Card>
         </div>
  


        </div>
    );
};

export default Gallery;